module.exports = __webpack_public_path__ + "images/exterior-tour-3d-95266fe81c2376466c6e1512111057e4.svg";